var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { onBeforeMount, provide, ref } from "vue";
import TheHeader from "@/components/app/header/TheHeader.vue";
import LoadingSpinner from "@/components/app/LoadingSpinner.vue";
import { initializeFieldsProvider, getFieldsRepository } from "@/providers/fields-provider";
import { FIELDS_INJECTION_KEY } from "@/core/fields/use-fields";
import "@/style.css";
export default /*@__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props, { expose: __expose }) {
        __expose();
        const isReady = ref(false);
        // Get the singleton FieldRepository instance and provide it immediately
        // It already has static fields loaded
        provide(FIELDS_INJECTION_KEY, getFieldsRepository());
        // Load dynamic fields from API
        onBeforeMount(() => __awaiter(this, void 0, void 0, function* () {
            yield initializeFieldsProvider();
            isReady.value = true;
        }));
        const __returned__ = { isReady, TheHeader, LoadingSpinner };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
